<template>
<div class="container-carrusel">
  <p style="text-align: left; font-size: 24px;" class="textoSubtitulo" >ANUNCIOS</p>
  <b-row class="m-3">
    <b-col class="columna-carrusel">
          <div style="border-radius: 30px;
          overflow: hidden;">
            <b-carousel v-if="loadingSliders === false"
            class="custom-carousel"
                id="carousel-fade"
                fade
                :interval="4000"
                indicators
                background="#ababab"
                img-width="500"
                img-height="200"
                style="text-shadow: 1% 1% 2% #333; left: 2%"
            >
              <b-carousel-slide
                  :img-src="require('../../../assets/banner genérico-0446.jpg')"
              ></b-carousel-slide>
            </b-carousel>

            <b-carousel
                v-else
                class="custom-carousel"
                id="carousel-fade"
                fade
                :interval="4000"
                indicators
                background="#ababab"
                img-width="500"
                img-height="200"
                style="text-shadow: 1% 1% 2% #333 "
            >
              <a
                  v-for="postal in postales"
                  :key="postal.idPostal"
                  :href="postal.link"
                  target="_blank"
              >
                <b-carousel-slide :img-src="postal.image"></b-carousel-slide>
              </a>
            </b-carousel>
          </div>
    </b-col>
  </b-row>
</div>
</template>

<script>
export default {
  name: "carruselDashboard",
  data: () => ({
    sessions: [
      {
        name: null,
      },
    ],
    active: false,
    showDialog: false,
    loadingSliders: false,
    postales: []
  }),
  created() {
    this.obtenerPostales();
  },
  methods:{
    obtenerPostales() {

      const processData = (response) => {
        return response.data.data.map(function (el) {
          var o = Object.assign({}, el);
          o.image = "data:image/png;base64," + o.dataFile;
          return o;
        });
      }
      this.$http
          .get(this.$api + "postal/postales")
          .then((response) => {
            if (response.status === 200) {
              this.$localStorageService.setPostales(response);
              this.postales = processData(response);
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.loadingSliders = true;
          });
      // }

    },
  }
}

</script>

<style scoped>
.custom-carousel {
  max-height: 200px; /* Aquí puedes ajustar el tamaño a tu gusto */
}
  .img-raton{
    margin-left: -8%; margin-top: 6%;
    flex-basis: 60%;
  max-width: 60%;

  } 

  .txt-raton{
    position: absolute;
    flex-basis: 60%;
  max-width: 70%;
  left: 32%;
  top: 23%;
  }

.container-dentino{
  left: 0px;
}

.container-carrusel{
  margin: 2% 0% 0% 6%;
  padding:1%;
  border-radius: 20px;
  background-color: #fff;
  box-shadow: 0px 6px 17px -4px rgba(0, 0, 0, 0.12);
}

  .columna-raton{
  height: 100%;
  flex-basis: 45%;
  max-width: 45%;
  
}

@media (max-width: 767px) {
  .columna-raton {
    flex-basis: 100%;
    max-width: 100%;
    margin-bottom: 9%;
  }

}

.columna-carrusel{
  flex-basis: 55%;
  max-width: 100%;
}

@media (max-width: 767px) {
  .columna-carrusel {
    flex-basis: 100%;
    max-width: 100%;
  }

}

#carousel-fade {
  width: 700px !important;
  max-width: 99% !important;
  min-width: 99% !important;
  height: 300px !important;
  max-height: 300px !important;
  min-height: 300px !important;
}
p{
  font-size: calc(0.75em + 1vmin);
  text-align: center;
}

.raton{
  max-width: 100%;
  object-fit: cover;
  object-position: bottom;
  margin-top: 2%;
  height: 15em;
  width: 18em;
}

@media screen and (max-width: 576px) {
  .raton {
    height: 8em;
    width: 10em;
  }
}

@media screen and (max-width: 1200px) {
  .raton {
    height: 11em;
    width: 13em;
  }

  .img-raton{
    margin-left: -12%; margin-top: 10%;
    flex-basis: 60%;
  max-width: 60%;

  } 
}

@media screen and (min-width: 1201px) {
  .raton {
    height: 14em;
    width: 16em;
  }

  .img-raton{
    margin-left: -12%; margin-top: 7%;
    flex-basis: 60%;
  max-width: 60%;

  } 
}

.responsivo {
  display: block;
  max-width: 100%;
  max-height: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  width: 98%;
  height: 30%;
  background-color: #f6f6f6 !important;
  margin: 1% !important;
  justify-content: center;
}

@media screen and (max-width: 500px) {
  .header-dashboard {
    display: flex;
    width: auto;
    height: auto;
    margin: 10px !important;
    margin-top: 10px !important;
    flex-direction: row;
    justify-content: flex-start;
  }
}

@media screen and (max-width: 576px) {
  #carousel-fade {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
    height: auto !important;
    max-height: none !important;
    min-height: auto !important;
  }

  .header-dashboard {
    display: flex;
    width: 100%;
    height: auto;
    margin: 10px !important;
    margin-top: 10px !important;
    flex-direction: column;
    justify-content: flex-start;
  }

  .carrusel {
    display: flex;
    /*display: block*/
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    /*   background-color: white !important; */
    background-color: #f6f6f6 !important;
    margin: 1% !important;
    justify-content: flex-start;
  }

  .cards {
    display: flex;
    flex-direction: row;
    margin: 50px !important;
    width: 100%;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  .cards-container {
    display: flex;
    flex-wrap: initial;
    flex-direction: column;
    margin: 1% !important;
    width: 22%;
    height: 10%;
    justify-content: space-between;
  }

  .responsivo {
    display: flex;
    /*display: block*/
    flex-direction: row;
    flex-wrap: wrap;
    width: 80%;
    height: 45%;
    /*   background-color: white !important; */
    background-color: #f6f6f6 !important;
    margin: 1% !important;
    justify-content: flex-start;
  }
}
/* @media only screen and (max-width: 600px) {
  .raton{
    max-width: 80%;
  }
}
@media only screen and (max-width: 928px) {
  .raton{
    max-width: 80%;
  } 
}*/

</style>
